<template>
  <vx-card>
    <vs-input class="inputx tree-search-input float-left mr-2" placeholder="Ara..." @keyup.enter="search"
      v-model.lazy="searchword" />
    <vs-button color="primary" type="filled" @click="search" class="mb-3 mr-3">Ara</vs-button>
    <vs-button color="primary" type="filled" @click="save" class="mb-3">Kaydet</vs-button>
    <!--   <div class="selected-nodes" style="margin-top: 20px;">
      <h6>Seçili Kategoriler:</h6>
      <span v-for="node in selectedNodes" :key="node.id" style="margin-right: 10px;">
        {{ node.title }}
      </span>
    </div>-->
    <vs-divider></vs-divider> 
    <v-tree :key="treeKey" ref="tree" :canDeleteRoot="true" :data="treeDataLocal" :draggable="true" :tpl="tpl"
      :halfcheck="true" :multiple="true" />
  </vx-card>
</template>

<script>
import { VTree, VSelectTree } from 'vue-tree-halower'
import Store from "../../../store/store";
import state from "../../../store/state";
export default {
  props: ["treeData", "findedCategories", "stock"],
  data() {
    return {
      searchword: '',
      treeKey: 0,
      treeDataLocal: []
    }
  },
  methods: {
    markNodesChecked(nodes, keys) {
      try {
        nodes.forEach(node => {
          if (keys.includes(node.id)) {
            node.checked = true;
          } else node.checked = false;
          if (node.children && node.children.length) {
            this.markNodesChecked(node.children, keys);
          }
        });
        this.treeKey += 1
      } catch (error) {
        console.log(error)
      }

    },
    save() {
      const checkedNodes = this.$refs.tree.getCheckedNodes();
      const checkedIds = checkedNodes.map(node => node.id);
      const getAllParentNodes = (nodes, checkedIds) => {
        const parentNodes = new Set();

        const traverse = (node, parentChain = []) => {
          if (checkedIds.includes(node.id)) {
            parentChain.forEach(p => parentNodes.add(p));
          }

          if (node.children && node.children.length > 0) {
            node.children.forEach(child => {
              traverse(child, [...parentChain, node]);
            });
          }
        };

        nodes.forEach(node => traverse(node));
        return Array.from(parentNodes);
      };

      const allParents = getAllParentNodes(this.treeDataLocal, checkedIds);
      const allSelected = [...checkedNodes, ...allParents];
      const uniqueNodes = Array.from(new Map(allSelected.map(n => [n.id, n])).values());
      this.saveCategories(uniqueNodes);
    },
    saveCategories(data) {
      var vm = this;
      const vs = this.$vs;

      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        STOCKID: vm.stock,
        INSERTUSERID: Store.state.UserId,
        CATEGORIES: JSON.stringify(data)
      }
      soap.createClient(url, function (err, client) {
        client.INT_Ins_StokCategories(args, function (err, result) {
          if (result.INT_Ins_StokCategoriesResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          try {
            let jsonData = JSON.parse(result.INT_Ins_StokCategoriesResult)
            if (jsonData.response == "Ok") {
              vs.notify({
                title: "Güncellendi",
                text: "Kategori güncellendi",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success",
                position: "top-center",
              });
            } else {
              vs.notify({
                title: "Hata Oluştu",
                text: jsonData.message,
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
            }
          } catch (error) {
            console.log(error)
          }

        });
      });

    },
    search() {
      this.$refs.tree.searchNodes(this.searchword)
    },
    tpl(...args) {
      const { 0: node, 2: parent, 3: index } = args
      let titleClass = node.selected ? 'node-title node-selected' : 'node-title'
      if (node.searched) titleClass += ' node-searched'
      return <span>
        {node.children &&
          <span class="tree-expand" onClick={() => {
            const hasSyncNode = node.children && node.children.length <= 0;
            if (!hasSyncNode) {
              this.$refs.tree.addNode(node);
            }
          }}>+</span>
        }
        <span class={titleClass} domPropsInnerHTML={node.title} onClick={() => {
          this.$refs.tree.nodeSelected(node)
        }}></span>
      </span>
    },
    buildTree(data) {
      let map = new Map();
      let tree = [];
      data.forEach(item => {
        const isTopLevel = item.STOCKCATEGORY_USTREF === 0;

        map.set(item.STOCKCATEGORY_ID, {
          id: item.STOCKCATEGORY_ID,
          title: item.STOCKCATEGORY_CATEGORY,
          expanded: isTopLevel, // sadece üst kırılım açık
          children: []
        });
      });

      data.forEach(item => {
        if (item.STOCKCATEGORY_USTREF === 0) {
          tree.push(map.get(item.STOCKCATEGORY_ID));
        } else if (map.has(item.STOCKCATEGORY_USTREF)) {
          map.get(item.STOCKCATEGORY_USTREF).children.push(map.get(item.STOCKCATEGORY_ID));
        }
      });

      return tree;
    },
  },
  components: {
    VTree,
    VSelectTree
  },
  watch: {
    findedCategories(newVal) {
      this.treeDataLocal = this.buildTree(this.treeData)
      this.markNodesChecked(this.treeDataLocal, this.findedCategories);
      return newVal
    },
  },
  mounted() {
    this.markNodesChecked(this.treeDataLocal, this.findedCategories);
  },
  computed: {
    /*selectedNodes() {
      console.log("123")
      const result = [];
      const traverse = nodes => {
        nodes.forEach(node => {
          if (node.checked) {
            result.push(node);
          }
          if (node.children && node.children.length) {
            traverse(node.children);
          }
        });
      };
      traverse(this.treeData);

      return result;
    },*/
  },
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/extraComponents/tree.scss";

button.btn-async {
  background: rgba(var(--vs-warning), 0.15);
}

button.btn-delete {
  background: rgba(var(--vs-danger), 0.15);
}
</style>
